export enum ModularHouseOfferHouseType {
    DETACHED = 1,
    SEMI_DETACHED = 2
}
export enum ModularHouseOfferHouseType {
    DETACHED = 1,
    SEMI_DETACHED = 2
}
